"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$default;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IST = __importStar(require("./incomeSourceTypes"));

var ISST = __importStar(require("./incomeSourceSubTypes"));

exports.default = (_exports$default = {}, _defineProperty(_exports$default, IST.BUSINESS, [ISST.INDEPENDENT_CONTRACTOR, ISST.RENTAL_PROPERTY]), _defineProperty(_exports$default, IST.EMPLOYEE, [ISST.FULL_TIME, ISST.PART_TIME, ISST.TEMPORARY]), _defineProperty(_exports$default, IST.GOVERNMENT, [ISST.UNEMPLOYMENT, ISST.SOCIAL_SECURITY, ISST.SUPPLEMENTAL_SECURITY_INCOME, ISST.SOCIAL_SECURITY_DISABILITY_INSURANCE, ISST.SNAP, ISST.TANF, ISST.SECTION_8, ISST.LIFELINE_PHONE, ISST.LIHEAP, ISST.CHIP, ISST.VA_DISABILITY, ISST.OTHER_GOVERNMENT_ASSISTANCE, ISST.PANDEMIC_UNEMPLOYMENT_ASSISTANCE]), _defineProperty(_exports$default, IST.INVESTMENT, [ISST.DIVIDENDS, ISST.INTEREST]), _defineProperty(_exports$default, IST.RESIDUALS_ROYALTIES, [ISST.RESIDUALS, ISST.ROYALTIES]), _defineProperty(_exports$default, IST.TAX_REFUND, []), _defineProperty(_exports$default, IST.OTHER, []), _defineProperty(_exports$default, IST.OUTSIDE_CONTRIBUTOR, [ISST.CROWD_FUNDING, ISST.COMMUNITY_ORGANIZATION, ISST.FAMILY, ISST.FRIEND]), _defineProperty(_exports$default, IST.RETIREMENT, [ISST.IRA, ISST.PENSION, ISST.PLAN_401K, ISST.PLAN_403B, ISST.PROFIT_SHARING_PLAN, ISST.ROTH_IRA]), _defineProperty(_exports$default, IST.SUPPORT, [ISST.ALIMONY, ISST.MAINTENANCE, ISST.FAMILY_SPOUSAL_SUPPORT, ISST.CHILD_SUPPORT, ISST.DIVORCE_SETTLEMENT, ISST.PROPERTY_SETTLEMENT]), _exports$default);